import { Method } from "../Config";
import { ResponseType, Gateway } from "./Gateway";

interface FAQListQueryParams {
    currentPage: string; // number
    type?: string; // number
    keyword?: string;
}

interface FAQType {
    type: string;
}

interface FAQViewID {
    id: string;
}

/**
 * @author smyun
 * @date 2025-05-19
 * @remark FAQ Gateway
 */

class FAQGateway extends Gateway {
    protected readonly _contextPath = "faq";
    protected readonly _pathParams?: { [key: string]: string };
    protected readonly _processParams = {
        type: "type",
        popularlist: "popularlist",
        paging: "paging",
        list: "list",
        view: "view",
    };

    // GET
    // type 조회
    public async reqFAQType(): Promise<ResponseType> {
        const queryParam = {
            process: this._processParams.type,
        };

        return await this.request(Method.GET, undefined, queryParam);
    }

    // 인기질문 조회
    public async reqFAQPopularList(param: FAQType): Promise<ResponseType> {
        const queryParam = {
            process: this._processParams.popularlist,
            ...param,
        };

        return await this.request(Method.GET, undefined, queryParam);
    }

    // 페이지 요소 계산 조회
    public async reqFAQPaging(param: FAQListQueryParams): Promise<ResponseType> {
        const queryParam = {
            process: this._processParams.paging,
            ...param,
        };

        return await this.request(Method.GET, undefined, queryParam);
    }

    // list 조회
    public async reqFAQList(param: FAQListQueryParams): Promise<ResponseType> {
        const queryParam = {
            process: this._processParams.list,
            ...param,
        };

        return await this.request(Method.GET, undefined, queryParam);
    }

    // view 조회
    public async reqFAQView(param: FAQViewID): Promise<ResponseType> {
        const queryParam = {
            process: this._processParams.view,
            ...param,
        };

        return await this.request(Method.GET, undefined, queryParam);
    }
}

export { FAQGateway, type FAQListQueryParams, type FAQType, type FAQViewID };
